import { authTool, clearSessionCache } from '../utils/auth-utils';
import createHttpClient from './http-client';

export async function updateAppSession(payload: any) {
  try {
    const httpClient = createHttpClient('');
    const response = await httpClient.post('/api/session', payload);

    if (response) {
      clearSessionCache();
      await authTool.refreshContextData(true);
    }
  } catch (error: any) {
    console.log('>>> error while updating app session', error.message);
    throw error;
  }
}
